import styled from "styled-components";

export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 10px;
	margin-top: 10px;
`;

export const BoxHeaderEditPart = styled.div`
	background: #fff;
	padding: 5px 15px;
	margin-bottom: 10px;
`;

export const Container = styled.p`
	font-size: 0.9rem;
	margin: 0;
`;

export const ContainerRow = styled.div``;
export const Label = styled.span`
	font-weight: bold;
	word-break: break-word;
`;
export const Text = styled.span`
	word-break: break-word;
`;

export const ContainerModalWarning = styled.div`
	display: flex;
	flex-direction: column;
	width: 90%;
	max-width: 500px;
	gap: 1rem;
	background: ${({ theme }) => theme.white};
	border-radius: 8px;
	padding: 1rem;

	h6 {
		font-weight: bold;
		color: #000;
		text-align: center;
	}
`;
